import React from 'react';

const whatsapp = ({
  width = 24,
  height = 24,
  rect = true,
  bgPath = true,
  bg = '#ffffff',
  color = '#25C277',
  className,
  strokeWidth = '1',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      strokeWidth={strokeWidth}>
      <g clipPath='url(#clip0_3004_17543)'>
        {rect && (
          <rect
            width={width}
            height={height}
            rx='12'
            fill={bg}
          />
        )}
        {bgPath && (
          <path
            d='M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z'
            fill={bg}
          />
        )}
        <path
          d='M17.3772 6.60575C16.0907 5.2814 14.3123 4.5625 12.4961 4.5625C8.63664 4.5625 5.53394 7.70305 5.57179 11.5246C5.57179 12.7354 5.91234 13.9085 6.47989 14.9679L5.49609 18.5625L9.16639 17.6166C10.188 18.1841 11.3231 18.449 12.4582 18.449C16.2799 18.449 19.3826 15.3085 19.3826 11.4868C19.3826 9.63275 18.6637 7.89225 17.3772 6.60575ZM12.4961 17.276C11.4745 17.276 10.4528 17.0111 9.58259 16.4814L9.35554 16.3679L7.16099 16.9354L7.72854 14.7787L7.57719 14.5517C5.91234 11.8652 6.70689 8.30845 9.43124 6.6436C12.1555 4.97871 15.6745 5.7733 17.3393 8.49765C19.0042 11.222 18.2096 14.7409 15.4853 16.4058C14.615 16.9733 13.5555 17.276 12.4961 17.276ZM15.8258 13.076L15.4096 12.8868C15.4096 12.8868 14.8042 12.622 14.4258 12.4327C14.388 12.4327 14.3501 12.3949 14.3123 12.3949C14.1988 12.3949 14.1231 12.4328 14.0474 12.4706C14.0474 12.4706 14.0096 12.5084 13.4799 13.1138C13.442 13.1895 13.3664 13.2274 13.2907 13.2274H13.2528C13.215 13.2274 13.1393 13.1896 13.1015 13.1517L12.9123 13.076C12.4961 12.8868 12.1177 12.6598 11.815 12.3571C11.7393 12.2814 11.6258 12.2057 11.5501 12.13C11.2853 11.8652 11.0204 11.5625 10.8312 11.2219L10.7934 11.1463C10.7555 11.1085 10.7555 11.0706 10.7177 10.995C10.7177 10.9193 10.7177 10.8436 10.7555 10.8057C10.7555 10.8057 10.9069 10.6165 11.0204 10.503C11.0961 10.4274 11.1339 10.3139 11.2096 10.2382C11.2853 10.1247 11.3231 9.9733 11.2853 9.8598C11.2474 9.6706 10.7934 8.649 10.6799 8.42195C10.6042 8.30845 10.5285 8.2706 10.415 8.23275H10.3015C10.2258 8.23275 10.1123 8.23275 9.99879 8.23275C9.92314 8.23275 9.84744 8.2706 9.77179 8.2706L9.73394 8.30845C9.65824 8.3463 9.58259 8.42195 9.50689 8.4598C9.43124 8.53545 9.39339 8.61115 9.31774 8.6868C9.05284 9.02735 8.90149 9.4436 8.90149 9.8598C8.90149 10.1625 8.97719 10.4652 9.09069 10.7301L9.12854 10.8436C9.46909 11.5625 9.92314 12.2057 10.5285 12.7733L10.6799 12.9247C10.7934 13.0382 10.9069 13.1139 10.9826 13.2274C11.7772 13.9085 12.6853 14.4004 13.7069 14.6652C13.8204 14.7031 13.9718 14.703 14.0853 14.7409C14.1988 14.7409 14.3501 14.7409 14.4637 14.7409C14.6528 14.7409 14.8799 14.6652 15.0312 14.5896C15.1447 14.5139 15.2204 14.5139 15.2961 14.4382L15.3718 14.3625C15.4474 14.2868 15.5231 14.249 15.5988 14.1733C15.6745 14.0976 15.7501 14.0219 15.788 13.9463C15.8637 13.7949 15.9015 13.6058 15.9393 13.4165C15.9393 13.3409 15.9393 13.2274 15.9393 13.1517C15.9393 13.1517 15.9015 13.1139 15.8258 13.076Z'
          fill={color}
          width={width}
          height={height}
        />
      </g>
      <defs>
        <clipPath id='clip0_3004_17543'>
          <rect
            width={width}
            height={height}
            rx='12'
            fill={color}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default whatsapp;
